import store from '@store';
import { APP_CONFIG } from '@constants';
import { CUSTOM_MESSAGES } from '@veriables';
import { getObjectValue } from '@utility/utills';
import { setConfirmStageSplit } from '@reducers/stage';
import { driveSplitCheck, orderFinalize, paymentCash } from '@reducers/payment';
import { setErrorPopUp } from '@reducers/notification';
import { flowType } from '@utility/userInfo';
import {
  setSeat,
  setPaymentCheck,
  priceCheck,
  setSyncData,
} from '@reducers/orders';
import { safeJsonParse } from '@utility/helperFunction';
import {
  syncCheckForPayment,
  updateCheckAfterPriceCheck,
  syncForPayment,
} from '@reducers/storeChecks';
import { getTotalAmount } from './CartActionHandler';
// Drive thru Payment Implementation
export const finaliseOrder = ({
  isDriveThru,
  isCounter,
  isTogo,
  isCallCenter,
  driveThruSelections,
  navigate,
}) => {
  const { orders, oauth } = store.getState();
  const driveThruInfo = getObjectValue(
    () => safeJsonParse(window.sessionStorage.getItem('auth'))?.driveThruInfo,
    null
  );
  const callCenterModeUserInfo = getObjectValue(
    () => safeJsonParse(window.sessionStorage.getItem('callCenterUserInfo')),
    {}
  );
  if ((isDriveThru || isCounter) && window.driveThruNameValidation) {
   const result = window.driveThruNameValidation.validateAndOpenModal();
    const isNameValid = result?.isValid ?? result;
    if (!isNameValid) {
        const isPhoneError = result?.errorType === 'phone';
      store.dispatch(
        setErrorPopUp({
          res: isPhoneError ? CUSTOM_MESSAGES().DT_PHONE_REQUIRED : CUSTOM_MESSAGES().DT_NAME_REQUIRED,
          noErrorTxt: true,
        })
      );
      return;
    }
  }

  if (isDriveThru && driveThruInfo) {
    const { storeConfig } = driveThruInfo;
    const { vehicleTypeRequired, vehicleColorRequired } = storeConfig || {};

    if (vehicleTypeRequired || vehicleColorRequired) {
      if (vehicleTypeRequired && driveThruSelections?.vehicleType == null) {
        store.dispatch(
          setErrorPopUp({
            res: CUSTOM_MESSAGES().DT_VEHICLE_TYPE,
            noErrorTxt: true,
          })
        );
        return;
      }

      if (vehicleColorRequired && driveThruSelections?.vehicleColor == null) {
        store.dispatch(
          setErrorPopUp({
            res: CUSTOM_MESSAGES().DT_VEHICLE_COLOR,
            noErrorTxt: true,
          })
        );
        return;
      }
    }
  }
  
  const taxExemptVal = safeJsonParse(window.sessionStorage.getItem('taxExempt'));
  const hasCondiment = getObjectValue(
    () => safeJsonParse(window.sessionStorage.getItem('condimentsMenus')) || [],
    []
  );
  const customerName = isDriveThru
    ? window.sessionStorage.getItem('counterName') || null
    : undefined;

 if (isCounter) {
    const checkHeader = orders.seats;
    
    const allCartItems = (orders.cart || []).map(item => ({
      ...item,
      modifiers: item.modifiers || [],
    }));

    if (allCartItems && allCartItems.length > 0) {
      let subtotalAmount = 0;
      const items = allCartItems.map(e => {
        subtotalAmount += e.price;
        return {
          menuItemId: e.menuItemId,
          quantity: e.quantity,
          modifiers: e.modifiers,
          price: e.price,
          note: e.note,
          menuScreenId: e.menuScreenId,
          menuId: e.menuId,
        };
      });

      const dataToSend = {
        deviceId: oauth?.deviceInformation?.deviceId,
        employeeId: Number(oauth?.loggedInUserData?.id ?? callCenterModeUserInfo?.employeeId),
        storeId: oauth?.deviceInformation?.storeId,
        checkHeaderId: orders?.seats?.id,
        items,
        subtotalAmount,
        taxExempt: taxExemptVal ? taxExemptVal : false,
         ...((isCallCenter) && { name: callCenterModeUserInfo?.name, phoneNumber: callCenterModeUserInfo?.phoneNumber, pickupTime: pickUpTime(callCenterModeUserInfo?.pickupTime[0]) })
      };

      if (hasCondiment.length > 0) {
        window.counterCondimentsModal?.open();
      }
      store
        .dispatch(orderFinalize(dataToSend))
        .then(resData => {
          if (hasCondiment.length === 0) {
            finalizeSplit({ data: resData, condimentItems: [], navigate });
          }
          store.dispatch(
            updateCheckAfterPriceCheck({
              ...resData,
              checkHeaderId: resData?.id,
            })
          );
          store.dispatch(
            setSeat({
              ...checkHeader,
              ...resData,
              checkHeaderId: resData?.id,
              items: allCartItems,
              itemAmount: resData.itemAmount,
              totalAmount: getTotalAmount({ ...resData, itemAmount: resData.itemAmount }),
            })
          );
          store.dispatch(
            setPaymentCheck({
              ...checkHeader,
              ...resData,
              checkHeaderId: resData?.id,
              items: allCartItems,
              itemAmount: resData.itemAmount,
              totalAmount: getTotalAmount({ ...resData, itemAmount: resData.itemAmount }),
            })
          );
        })
        .catch(err => {
          store.dispatch(
            setErrorPopUp({
              res: err.message,
            })
          );
        });
    } else {
      store.dispatch(
        setErrorPopUp({
          res: CUSTOM_MESSAGES().NO_ITEM_MSG,
        })
      );
    }
    return;
  }
const inProcessItem = orders.cart;
  let subtotalAmount = 0;
  const items = inProcessItem.map(e => {
    subtotalAmount += e.price;
    return {
      menuItemId: e.menuItemId,
      quantity: e.quantity,
      modifiers: e.modifiers,
      price: e.price,
      note: e.note,
      menuScreenId: e.menuScreenId,
      menuId: e.menuId,
    };
  });

  const dataToSend = {
    deviceId: oauth.deviceInformation.deviceId,
    employeeId: Number(oauth?.loggedInUserData?.id ?? callCenterModeUserInfo?.employeeId),
    storeId: oauth.deviceInformation.storeId,
    checkHeaderId: orders.seats?.id,
    items,
    driveThruLaneNumberMenuItemId: driveThruSelections?.lane ?? null,
    driveThruVehicleTypeMenuItemId: driveThruSelections?.vehicleType ?? null,
    driveThruVehicleColorMenuItemId: driveThruSelections?.vehicleColor ?? null,
    subtotalAmount,
    taxExempt: taxExemptVal ? taxExemptVal : false,
    ...(isDriveThru && { name: customerName }),
    ...((isCallCenter) && { name: callCenterModeUserInfo?.name, phoneNumber: callCenterModeUserInfo?.phoneNumber, pickupTime: pickUpTime(callCenterModeUserInfo?.pickupTime[0]) })
  };

  store
    .dispatch(orderFinalize(dataToSend))
    .then(resData => {
      store.dispatch(
        updateCheckAfterPriceCheck({
          ...resData,
          checkHeaderId: resData?.id,
        })
      );
      store.dispatch(
        setSeat({
          ...resData,
          checkHeaderId: resData?.id,
          items: resData?.items,
          itemAmount: isDriveThru ? resData.itemAmount : resData.subTotalAmount,
          totalAmount: isDriveThru
            ? getTotalAmount({ ...resData, itemAmount: resData.itemAmount })
            : getTotalAmount({
                ...resData,
                itemAmount: resData.subTotalAmount,
              }),
        })
      );
      store.dispatch(
        setPaymentCheck({
          ...resData,
          checkHeaderId: resData?.id,
          items: resData?.items,
          itemAmount: isDriveThru ? resData.itemAmount : resData.subTotalAmount,
          totalAmount: isDriveThru
            ? getTotalAmount({ ...resData, itemAmount: resData.itemAmount })
            : getTotalAmount({
                ...resData,
                itemAmount: resData.subTotalAmount,
              }),
        })
      );

      if ((isDriveThru || isTogo) && hasCondiment.length <= 0) {
        finalizeSplit({ data: resData, navigate });
        navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${resData?.check?.id}?ticketSplitTypeId=1&splitValue=1&screenType=32&type=payType`,
          { replace: true }
        );
      }
    })
    .catch(err => {
      store.dispatch(
        setErrorPopUp({
          res: err.message,
          onClickChange: () => window.counterCondimentsModal?.close(),
        })
      );
    });
  if (hasCondiment.length > 0) {
    window.counterCondimentsModal?.open();
  }
};
export const finalizeSplit = ({ data = {}, condimentItems = [], navigate }) => {
  const { oauth } = store.getState();
  const dataToSendToAdd = {
    deviceId: oauth.deviceInformation.deviceId,
    employeeId: oauth.loggedInUserData?.id,
    checkHeaderId: data?.id,
    storeId: data?.storeId,
    unpaidAmount: data?.unpaidAmount,
    totalAmount: data?.totalAmount,
    paidAmount: data?.paidAmount,
    splitType: 0,
    condimentItems: condimentItems,
  };
  store
    .dispatch(driveSplitCheck(dataToSendToAdd))
    .then(res => {
      const syncedCheck = res?.check || data;
      let updatedData = {
        ...syncedCheck,
        control: res?.control,
        checkHeaderId: res?.checkHeaderId,
        storeId: res?.storeId,
        giftCard: res?.giftCard,
        offer: res?.offer,
        paymentCheck: res?.paymentCheck,
        paymentChecks: res?.paymentChecks,
        availableLoyaltyOffers: res?.availableLoyaltyOffers,
        check: res?.check,
      };
      store.dispatch(setSeat(updatedData));
      store.dispatch(setPaymentCheck(updatedData));
      navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${res?.check?.id}?ticketSplitTypeId=1&splitValue=1&screenType=32&type=payType`,
        { replace: true }
      );
    })
    .catch(err => {
      store.dispatch(
        setErrorPopUp({
          res: err.message,
        })
      );
    });
};

export const speedOrderRouteToPay = (checkHeader, navigate) => {
  const { oauth, orders } = store.getState();
  const { deviceInformation, loggedInUserData } = oauth;
  const { seats } = orders;
  const Items = checkHeader?.orders[0]?.items;
  const data = (Items || []).reduce((a, v) => {
    if (v.pending) {
      a.push({
        ...v,
        ...JSON.parse(v.orderJson),
        menuScreenId: getObjectValue(
          () => JSON.parse(JSON.parse(v.orderJson).menuScreenId),
          0
        ),
        menuId: getObjectValue(
          () => JSON.parse(JSON.parse(v.orderJson).menuId),
          0
        ),
      });
    }
    return a;
  }, []);
  if (data && data.length > 0) {
    let subtotalAmount = 0;
    const items = data.map(e => {
      subtotalAmount += e.price;
      return {
        menuItemId: e.menuItemId,
        quantity: e.quantity,
        modifiers: e.modifiers,
        price: e.price,
        note: e.note,
        menuScreenId: e.menuScreenId,
        menuId: e.menuId,
      };
    });
    const dataToSend = {
      deviceId: deviceInformation.deviceId,
      employeeId: Number(loggedInUserData.id),
      storeId: deviceInformation.storeId,
      checkHeaderId: checkHeader.id,
      items,
      subtotalAmount,
    };
    store
      .dispatch(priceCheck(dataToSend))
      .then(resData => {
        store.dispatch(
          setSeat({
            ...checkHeader,
            ...resData,
            items: data,
            itemAmount: resData.subTotalAmount,
            totalAmount: getTotalAmount({
              ...resData,
              itemAmount: resData.subTotalAmount,
            }),
          })
        );
        store.dispatch(
          updateCheckAfterPriceCheck({
            ...checkHeader,
            ...resData,
          })
        );
        store
          .dispatch(
            setPaymentCheck({
              ...checkHeader,
              ...resData,
              items: data,
              itemAmount: resData.subTotalAmount,
              totalAmount: getTotalAmount({
                ...resData,
                itemAmount: resData.subTotalAmount,
              }),
            })
          )
          .then(() => {
            navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${seats.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
              { replace: true }
            );
          });
      })
      .catch(err => {
        store.dispatch(
          setErrorPopUp({
            res: err.message,
          })
        );
      });
  } else {
    store.dispatch(
      setErrorPopUp({
        res: CUSTOM_MESSAGES().NO_ITEM_MSG,
      })
    );
  }
};
export const payRoute = (checkHeader, navigate, onZeroUnpaid) => {
  const { oauth, orders } = store.getState();
  const { deviceInformation, loggedInUserData } = oauth;
  const { seats } = orders;
  if (activateGiftCards(checkHeader)) {
    navigate(`${APP_CONFIG.BASE_URL}/giftcard/${seats?.id}`, {
      replace: true,
    });
    return;
  }
  const isPendingItemsPresent = checkPendingItemsPresent(checkHeader);

  const isServerApp = flowType() === 'serverApp';
  if (isPendingItemsPresent && isServerApp) {
    store.dispatch(
      setErrorPopUp({
        res: CUSTOM_MESSAGES().PAYMENT_ERROR_HAVING_UNSENT,
      })
    );
  } else {
    const dataToSend = {
      deviceId: deviceInformation.deviceId,
      employeeId: Number(loggedInUserData?.id),
      storeId: deviceInformation.storeId,
      checkHeaderId: checkHeader.id,
      totalAmount: checkHeader.totalAmount,
      unpaidAmount: +checkHeader.unpaidAmount,
      paidAmount: checkHeader.paidAmount,
    };
    store
      .dispatch(syncForPayment(dataToSend))
      .then(res => {
        const data = res.check || checkHeader;
        store.dispatch(
          setSeat({
            ...data,
            subTotalAmount: getSubTotalAmount(data),
            totalAmount: getTotalAmount(data),
            control: res?.control,
            checkHeaderId: res?.checkHeaderId,
            storeId: res?.storeId,
            giftCard: res?.giftCard,
            offer: res?.offer,
            paymentCheck: res?.paymentCheck,
            paymentChecks: res?.paymentChecks,
          })
        );
        store.dispatch(
          setSyncData({
            ...data,
            subTotalAmount: getSubTotalAmount(data),
            totalAmount: getTotalAmount(data),
            control: res.control,
          })
        );
        if (Number(data.unpaidAmount) !== 0) {
          store.dispatch(setConfirmStageSplit(false));
          store
            .dispatch(
              setPaymentCheck({
                ...data,
                subTotalAmount: getSubTotalAmount(data),
                totalAmount: getTotalAmount(data),
              })
            )
            .then(() => {
              navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${data.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
                { replace: true }
              );
            });
        } else if (onZeroUnpaid) {
          onZeroUnpaid(data);
        }
      })
      .catch(err => {
        store.dispatch(
          setErrorPopUp({
            res: err.message,
          })
        );
      });
  }
};
export const stageRoute = checkHeader => {
  // TODO: Move Later to switch statement
  // setPayLoading(true);
  // setPayLoadingData('Synchronizing check');
  const { oauth, orders } = store.getState();
  const { deviceInformation, loggedInUserData } = oauth;
  const { seats } = orders;

  const dataToSend = {
    deviceId: deviceInformation.deviceId,
    employeeId: Number(loggedInUserData.id),
    storeId: deviceInformation.storeId,
    checkHeaderId: checkHeader.id,
    totalAmount: checkHeader.totalAmount,
    unpaidAmount: Number(checkHeader.unpaidAmount),
    paidAmount: checkHeader.paidAmount,
  };
  store
    .dispatch(syncCheckForPayment(dataToSend))
    .then(res => {
      const data = res || checkHeader;
      store.dispatch(
        setSeat({
          ...data,
          subTotalAmount: getSubTotalAmount(data),
          totalAmount: getTotalAmount(data),
        })
      );
      const isPendingItemsPresent = checkPendingItemsPresent(data);
      const isServerApp = flowType() === 'serverApp';
      if (isPendingItemsPresent && isServerApp) {
        store.dispatch(
          setErrorPopUp({
            res: CUSTOM_MESSAGES().PAYMENT_ERROR_HAVING_UNSENT,
          })
        );
        // TODO: Use Custom event later to send message
        // setPayLoading(false);
      } else {
        store.dispatch(setConfirmStageSplit(false));
        store
          .dispatch(
            setPaymentCheck({
              ...data,
              subTotalAmount: getSubTotalAmount(data),
              totalAmount: getTotalAmount(data),
            })
          )
          .then(() => {
            navigate(`${APP_CONFIG.BASE_URL}/stage/${data.id}`, {
              replace: true,
            });
          });
      }
    })
    .catch(err => {
      setPayLoading(false);
      store.dispatch(
        setErrorPopUp({
          res: err.message,
        })
      );
    });
};
//  ($0 unpaid) 
export const handleCashPayment = () => {
  const { oauth, orders } = store.getState();
  const { deviceInformation, loggedInUserData } = oauth;
  const seats = orders.seats;
  const loyaltyData = getObjectValue(
    () => safeJsonParse(window.sessionStorage.getItem('loyaltyData')),
    {}
  );
  const dataToSend = {
    storeId: deviceInformation.storeId,
    deviceId: deviceInformation.deviceId,
    employeeId: Number(loggedInUserData?.id),
    checkHeaderId: seats?.id,
    employeeCard: getObjectValue(
      () => safeJsonParse(window.sessionStorage.getItem('userInfo')).employeeCard,
      null
    ),
    ticketSplitTypeId: 1,
    splitValue: 1,
    paymentStageId: null,
    subTotalAmount: seats?.subTotalAmount,
    taxAmount: seats?.taxAmount || 0.0,
    seatIds: (seats?.seats || []).reduce((a, v) => {
      if (v.open) a.push(v.id);
      return a;
    }, []),
    serviceChargeAmount: seats?.serviceChargeAmount || 0.0,
    discountAmount: 0.0,
    orderPay: false,
    speedOrder: false,
    accountNumber: loyaltyData?.accountNumber || '',
    offerId: loyaltyData?.offerId || '',
    isCoupon: loyaltyData?.isCoupon || false,
  };

  return store.dispatch(paymentCash(dataToSend)).catch(err => {
    store.dispatch(setErrorPopUp({ res: err.message }));
    throw err;
  });
};
const getSubTotalAmount = table => {
  return +table.subTotalAmount;
};
const checkPendingItemsPresent = data => {
  return data?.orders?.[0]?.items?.some(item => item.pending === true);
};
const activateGiftCards = data => {
  let value = false;
  if (data.cards?.length > 0) {
    value =
      data.cards.some(card => card.status !== 5 && !card.void) &&
      !data.orders[0]?.items?.some(item => item?.pending === true);
  }
  return value;
};
export const pickUpTime =(time) =>  {
    if (time?.split(" ")[1] == "PM") {
      let timeVal = time.split(" ")[0].substring(0, 2)
      if (timeVal !== "12") {
        timeVal = Number(timeVal) + 12;
        let timeVal2 = time.split(" ")[0].substring(2)
        return timeVal + timeVal2;
      }
      return time.split(" ")[0];
    } else {
      let timeVal = time.split(" ")[0].substring(0, 2)
      if (timeVal === "12") {
        timeVal = Number(timeVal) - 12
        let timeVal2 = time.split(" ")[0].substring(2)
        return timeVal + "0" + timeVal2;
      }
      return time.split(" ")[0];
    }
  }

